import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-accept-review.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessAcceptReview';

class AgentBookingMailInprocessAcceptReviewCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessAcceptReview implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessAcceptReviewCtrl];
}

export default MODULE_NAME;
